import { render, staticRenderFns } from "./linkin.vue?vue&type=template&id=082a5854&scoped=true"
import script from "./linkin.vue?vue&type=script&lang=js"
export * from "./linkin.vue?vue&type=script&lang=js"
import style0 from "./linkin.vue?vue&type=style&index=0&id=082a5854&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082a5854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('082a5854')) {
      api.createRecord('082a5854', component.options)
    } else {
      api.reload('082a5854', component.options)
    }
    module.hot.accept("./linkin.vue?vue&type=template&id=082a5854&scoped=true", function () {
      api.rerender('082a5854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hr/recruiter/linkin.vue"
export default component.exports